







import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class IconSvg extends Vue {
  @Prop({ default: "" })
  private iconClass!: string;

  get iconName() {
    return `#icon_${this.iconClass}`;
  }

  private created() {}

  private mounted() {}
}
